import Box from '@redbubble/design-system/src/Box';
import Collapsible from '@redbubble/design-system/src/Collapsible';
import Divider from '@redbubble/design-system/src/Divider';
import Modal, { ModalBody } from '@redbubble/design-system/src/Modal';
import Text from '@redbubble/design-system/src/Text';
import { useIntl } from '@redbubble/next/intl';
import { styleSwitchMessages as messages } from './messages';
import { useProductStyleContext } from './ProductStyleContext';
import { modalCloseRequested } from './useProductStyleSwitcherState';

interface StatefulCollapseProps {
  children?: React.ReactNode;
  open: boolean;
}
/**
 * wrapper component around the Collapsible component from the DS.
 * Collapsible only allows control of the collapsed state from the "trigger" prop
 * instead of just setting a simple "opened" prop.
 * this component allows this behaviour.
 */
export const StatefulCollapse: React.FC<StatefulCollapseProps> = ({
  children,
  open,
}) => {
  return (
    <Collapsible
      defaultCollapsed={!open}
      trigger={({ collapsed, toggleCollapsible }) =>
        open
          ? collapsed && toggleCollapsible()
          : !collapsed && toggleCollapsible()
      }
    >
      {children}
    </Collapsible>
  );
};

export const ModalDivider: React.FC<{}> = () => {
  return (
    <Box data-testid="modalDivider" marginBottom="l" marginTop="l">
      <Divider color="var(--ds-color-border-light)" />
    </Box>
  );
};

interface ProductStyleModalProps {
  children?: React.ReactNode;
}

export const ProductStyleModal: React.FC<ProductStyleModalProps> = ({
  children,
}) => {
  const { state, dispatch } = useProductStyleContext();
  const intl = useIntl();

  const onCloseRequested = () => modalCloseRequested(dispatch);

  return (
    <Modal
      open={state.styleSelectOpen}
      onCloseRequested={onCloseRequested}
      accessibleTitle={intl.formatMessage(messages.title)}
      // TODO: Determine profile
      // profile={profile}
    >
      <ModalBody padded={false}>
        <Box
          padding="m"
          // TODO: Get padding from profile
          // paddingTop={profile === constants.MOBILE ? 'xl' : undefined}
        >
          <Text display="block" marginBottom="m" type="display3">
            {intl.formatMessage(messages.title)}
          </Text>
          {children}
        </Box>
      </ModalBody>
    </Modal>
  );
};
